import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	nextStepItem: {
		padding: "12px",
		backgroundColor: themeColors.colors.system.purple[50],
		borderRadius: "8px",
		color: themeColors.colors.system.gray[800],
		fontSize: "0.875rem"
	},
	nextStepIconContainer: {
		width: "28px",
		height: "28px",
		borderRadius: "8px",
		backgroundColor: themeColors.colors.system.purple[200],
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		color: themeColors.colors.system.purple[700]
	}
}))

export default useStyles
